// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1Zfw-","approved":"Status_approved__3y--5","rejected":"Status_rejected__1YL66","expired":"Status_expired__gI7BY","label":"Status_label__f2-5e"};